import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { CloseIcon } from '@calendly/ui/components/icons';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState, forwardRef } from 'react';
const bannerWrapperIsBigPhoneUpCss = "b18rk3nm";
const bannerWrapperStatusErrorCss = "bodxg96";
const bannerWrapperStatusWarningCss = "b1xbcfdf";
const bannerWrapperStatusSuccessCss = "bjcaxw9";
const bannerWrapperStatusInfoCss = "b1htllol";
const bannerWrapperStatusSystemCss = "b976ofz";
const bannerWrapperCss = "bs7vd5i";
const BannerWrapper = forwardRef((props, ref) => {
  const {
    status
  } = props;
  const isBigPhoneUp = useDeviceType('isBigPhoneUp');
  return <FixedContainer ref={ref} {...props} className={classNames(bannerWrapperCss, {
    [bannerWrapperIsBigPhoneUpCss]: isBigPhoneUp,
    [bannerWrapperStatusErrorCss]: status?.toString() === 'error',
    [bannerWrapperStatusWarningCss]: status?.toString() === 'warning',
    [bannerWrapperStatusSuccessCss]: status?.toString() === 'success',
    [bannerWrapperStatusInfoCss]: status?.toString() === 'info',
    [bannerWrapperStatusSystemCss]: status?.toString() === 'system'
  }, props.className)} />;
});
const bannerTitleCss = "bf5d4qh";
const BannerTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bannerTitleCss, props.className)} />;
});
const bannerContentIsBigPhoneUpCss = "b1awewu1";
const bannerContentCss = "b1oqi5nc";
const BannerContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isBigPhoneUp = useDeviceType('isBigPhoneUp');
  return <Component ref={ref} {...restProps} className={classNames(bannerContentCss, {
    [bannerContentIsBigPhoneUpCss]: isBigPhoneUp
  }, props.className)} />;
});
const buttonWrapperCss = "b95u15h";
const ButtonWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(buttonWrapperCss, props.className)} />;
});
const closeButtonCss = "cf6pkp0";
const CloseButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(closeButtonCss, props.className)} />);
export const Banner = ({
  title,
  body,
  show,
  onClose,
  status,
  delay = 3000
}) => {
  const [visible, setVisible] = useState(false);
  const closeBanner = useCallback(() => {
    setVisible(false);
    onClose();
  }, [onClose]);
  useEffect(() => {
    setVisible(show);
  }, [show]);
  useEffect(() => {
    const shouldAutoclose = () => status === 'success' || status === 'info';
    let timer;
    if (shouldAutoclose()) {
      timer = setTimeout(closeBanner, delay);
    }
    return () => clearTimeout(timer);
  }, [closeBanner, delay, status]);
  return visible && <BannerWrapper status={status}>
    <BannerContent>
      {title && <BannerTitle>
        {`${title} `}
      </BannerTitle>}
      <div>{body}</div>
    </BannerContent>
    <ButtonWrapper>
      <CloseButton aria-label={I18n.t('publisher.action.close')} onClick={closeBanner}>
        <CloseIcon />
      </CloseButton>
    </ButtonWrapper>
  </BannerWrapper>;
};
Banner.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  delay: PropTypes.number,
  status: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired
};

require("./banner.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./banner.js");